import { ViewModel } from './_vm'

/**
 * tourDetailRoomAllocation // ホテル詳細の描写
 *
 * @returns {undefined}
 */
export class TourDetailRoomAllocation extends ViewModel {
  constructor($element, controller) {
    super(TourDetailRoomAllocation.name(), $element, controller)

    // イベントの登録
    this.on(`tourDetailRoomAllocation`, () => this.render())
  }

  static name() {
    return 'TourDetailRoomAllocation'
  }

  static className() {
    return '.js-tour-detail-room-allocation'
  }

  /**
   * render // イベントを設定する
   */
  render() {
    const data = this.controller.action('roomAllocation')
    // this.controller.action('lockRooms')
    console.log('lockRooms')
    this.$element.empty()
    this.$element.append(this.view(data))
    // this.hook('FormSelect')
    this.trigger('TopRoomChange:render')
    // this.off('GadgetButton')
    // this.hook('GadgetButton')
    this.hook('GadgetPeopleButton')
    this.trigger('GadgetPeopleButton')
    this.trigger('GadgetPeopleButton:countCheck')
  }

  template() {
    return `
{% for room in rooms %}
<div class="roomAllocation__room">
  <div class="roomAllocation__row">
    <div class="roomAllocation__title">人数（{{ room.no }}部屋目）</div>
    <div class="roomAllocation__body">
      <div class="roomAllocation__item">
        <div class="roomAllocation__label">大人(12歳以上)</div>
        <div class="roomAllocation__form js-kaigai-gadget-people-button" name="room{{ room.no }}age20r">
        <div
          class="topUserSelectController__button minus_count_people"
          name="room{{ room.no }}age20r"
        >−</div>
        <div
          class="room{{ room.no }}age20r"
          name="room{{ room.no }}age20r"
          data-room{{ room.no }}age20r="1"
        >1</div>
        <div
          class="topUserSelectController__button plus_count_people"
          name="room{{ room.no }}age20r"
          >+</div>
        </div>
      </div>
      <div class="roomAllocation__item">
        <div class="roomAllocation__label">子供(2〜11歳)</div>
        <div class="roomAllocation__form js-kaigai-gadget-people-button" name="room{{ room.no }}age6r">
          <div
            class="topUserSelectController__button minus_count_people"
            name="room{{ room.no }}age6r"
          >−</div>
          <div
            class="room{{ room.no }}age6r"
            name="room{{ room.no }}age6r"
            data-room{{ room.no }}age6r="0"
          >0</div>
          <div
            class="topUserSelectController__button plus_count_people"
            name="room{{ room.no }}age6r"
          >+</div>
        </div>
      </div>
      <div class="roomAllocation__item">
        <div class="roomAllocation__label">幼児(0〜1歳)</div>
        <div class="roomAllocation__form js-kaigai-gadget-people-button" name="room{{ room.no }}age0r">
          <div
            class="topUserSelectController__button minus_count_people"
            name="room{{ room.no }}age0r"
          >−</div>
          <div
            class="room{{ room.no }}age0r"
            name="room{{ room.no }}age0r"
            data-room{{ room.no }}age0r="0"
          >0</div>
          <div
            class="topUserSelectController__button plus_count_people"
            name="room{{ room.no }}age0r"
          >+</div>
        </div>
      </div>
    </div>
  </div>
</div>
{% endfor %}
`
  }
}
